import './screen/hero-slider';
import './screen/content-slider';
import './screen/card-slider';
import './screen/dropdown-menu';
import './screen/mobile-menu';
import './screen/floating-labels';
import './screen/tabs';
import './screen/contact-persons';
import './screen/header-search';
import './screen/timeline';

